module.exports = __webpack_public_path__ + "static/media/heart-min.352e69f2.png";